import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@cwos/ui-shared';
import { Icon } from '../icon/Icon';
import styles from './notes.module.css';
export function DegradedSourceNote({ connectorNames, href = '/records', onNavigate, }) {
    if (connectorNames.length === 0)
        return null;
    return (_jsxs("div", { className: styles.staleness, role: "note", children: [_jsx(Icon, { name: "look", className: styles.stalenessIcon }), _jsx("div", { className: styles.stalenessBody, children: connectorNames.map((name) => (_jsxs("p", { children: [t('provenance.connectorDegraded', { name }), ' ', _jsx("a", { href: href, onClick: (e) => {
                                if (onNavigate) {
                                    e.preventDefault();
                                    onNavigate(href);
                                }
                            }, children: t('provenance.openIntegrationCenter') })] }, name))) })] }));
}
//# sourceMappingURL=DegradedSourceNote.js.map